module.exports = __webpack_public_path__ + "img/apps.c4bcd5a6.svg";